module.exports = __webpack_public_path__ + "img/856399a.jpg";